//
// Copyright (c) 2021 Astute Global, Inc.
//

import AttributesModule from "modules/shared/attributes/attributesModule";
import MarionetteView from "../../marionetteView";
import { uid } from "ckeditor5";
import Messenger from "messaging/messenger";

export default class ResponseAttributesListView extends MarionetteView {
  constructor(locale) {
    super(locale);
    this.set("attributeId", null);
    this.set("attributeName", null);
    this.set("responseId", null);
    this.namespace = "responseAttributes-" + uid();
  }

  createModule() {
    const module = new AttributesModule({
      region: this.region,
      namespace: this.namespace,
    });
    this.on("change:attributeId", (evt, name, newAttributeId) => {
      module.setSelected(newAttributeId);
    });
    return module;
  }

  focus() {
    if (this.module) {
      this.module.focus();
    }
  }

  setUpVents() {
    Messenger.vent.on(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onListItemSelected,
      this,
    );
  }

  showModule() {
    this.module.show({
      responseId: this.responseId,
    });
    this.module.setSelected(this.variableId);
  }

  tearDownVents() {
    Messenger.vent.off(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onListItemSelected,
      this,
    );
  }

  _onListItemSelected(model) {
    this.attributeId = model.get("id");
    this.attributeName = model.get("name");
  }
}
